import React, { createContext, FC, useContext } from "react";

import { SGisSymbol } from "../../../react-sgis/symbols/SymbolRenderer/serializeSymbol";

export interface SymbolSettingsContextType {
  ableClassify?: boolean;
  inputWidth?: string;
  previewSize?: string;
  previewRenderSize: number;
  mini?: boolean;
  symbolInstance?: SGisSymbol;
  toggleExtendedAttrAggr?: VoidFunction;
}

export const defaultSymbolSettingsContext: SymbolSettingsContextType = {
  ableClassify: true,
  inputWidth: "7rem",
  previewSize: "7rem",
  previewRenderSize: 112,
  mini: false,
};

const SymbolSettingsContext = createContext<SymbolSettingsContextType>(defaultSymbolSettingsContext);

export const SymbolSettingsProvider: FC<{ settings: SymbolSettingsContextType }> = ({ settings, children }) => (
  <SymbolSettingsContext.Provider value={settings}>{children}</SymbolSettingsContext.Provider>
);

export const useSymbolSettingsContext = (): SymbolSettingsContextType => {
  return useContext(SymbolSettingsContext);
};
